import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import Policy from "./page/Policy";
import Footer from "./Footer";
import Support from "./page/Support";
import Home from "./page/Home";
import Uptime from "./page/Uptime";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route element={<Home />} path=""></Route>

          <Route
            element={<Policy />}
            path="2023/02/07/hivex-data-management-and-policy/"
          ></Route>
          <Route
            element={<Policy />}
            path="hivex-data-management-and-policy/"
          ></Route>

          <Route
            element={<Support />}
            path="hivex_issuer_customersupport/PP"
          ></Route>

          <Route element={<Uptime />} path="hivex-uptime"></Route>
          <Route
            path="*"
            element={
              <main style={{ padding: "1rem" }}>
                <p>There's nothing here!</p>
              </main>
            }
          />
        </Routes>
      </Router>
      <Footer />
    </div>
  );
}
export default App;
